module.exports = __webpack_public_path__ + "static/media/Discovery_Kids_Museum_undersea_mural_Final_Huntersville_NC_2012.0d03d947.webp";